import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export type AccentColor = 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info';

/** Outlined card whose border and icons take a palette accent; `interactive` adds the pointer and hover fill. */
export const AccentCard = styled(Card, {
  shouldForwardProp: prop => prop !== 'accent' && prop !== 'accentShade' && prop !== 'interactive',
})<{ accent: AccentColor; accentShade?: 'light' | 'main' | 'dark'; interactive?: boolean }>(
  ({ theme, accent, accentShade = 'main', interactive = false }) => ({
    borderColor: theme.palette[accent][accentShade],
    borderWidth: 1,
    cursor: interactive ? 'pointer' : 'default',
    '& .MuiSvgIcon-root': { color: theme.palette[accent][accentShade] },
    ...(interactive && { '&:hover': { backgroundColor: theme.palette.action.hover } }),
  }),
);
